import { useBoundStore } from 'app/store';
import { IconTitleDescButton } from 'shared/ui/onBoarding';
import { ReactComponent as WarningIcon } from 'styles/images/onboarding-warning-icon.svg';

export const AuthError = () => {
  const { retryUrl } = useBoundStore((state) => state['kareNote'].serviceParams);

  return (
    <IconTitleDescButton
      title={<>본인인증에 실패했어요</>}
      desc={
        <>
          입력하신 정보가 일치하지 않거나
          <br />
          인증 과정에서 문제가 발생했어요.
          <br />
          잠시 후 다시 시도해 주세요.
        </>
      }
      icon={<WarningIcon />}
      buttons={[
        {
          label: '닫기',
          variant: 'secondary',
          onClick: () => {
            if (/android/i.test(navigator.userAgent)) {
              window.location.href = 'kakaotalk://inappbrowser/close';
            }

            if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
              window.location.href = 'kakaotalk://web/close';
            }
          },
        },
        {
          label: '다시 시도',
          variant: 'primary',
          onClick: () => {
            window.location.replace(retryUrl);
          },
        },
      ]}
    />
  );
};

